module.exports = __webpack_public_path__ + "resources/img/img_application_service_mesimesb.ee5e5616b6d45a05e67ca95757504171.png";